<template>
  <vs-dropdown>
    <div
      class="flex-1 flex flex-col lg:flex-row text-grey items-center lg:mb-5 p-3"
      :class="{ 'text-primary': false }"
      v-if="navigations.length > 0"
    >
      <div class="lg:pr-2">
        <feather-icon
          class="hidden lg:block"
          :icon="'MoreHorizontalIcon'"
        ></feather-icon>
        <feather-icon
          class="lg:hidden"
          :icon="'MoreHorizontalIcon'"
          :badge="0"
        ></feather-icon>
      </div>
      <div class="text-xs font-semibold flex-1">Lainnya</div>
    </div>
    <!-- TODO: FIX THIS, CREATE WITH MODAL -->
    <vs-dropdown-menu>
      <vs-dropdown-item v-for="(item, index) in navigations" :key="index">
        <div
          class="nav-item cursor-pointer flex items-center py-2"
          style="min-width:200px"
          @click="clicked(item)"
        >
          <div class="mr-3">
            <feather-icon
              class="lg:hidden"
              :icon="item.icon"
              :badge="0"
            ></feather-icon>
          </div>
          <div class="flex-1 text-lg">{{ item.text }}</div>
          <vs-chip
            :color="item.badgeColor || 'primary'"
            v-if="item.badge > 0"
            >{{ item.badge }}</vs-chip
          >
        </div>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    navigations: {
      type: Array
    }
  },
  methods: {
    clicked(item) {
      if (this.$route.path !== item.to) this.$router.push(item.to);
      this.setNavigationActive(item.active);
      this.$store.dispatch("globalApp/setShowDetail", false);
      this.$store.dispatch("globalApp/toggleCreate", false);
      this.$store.dispatch("globalApp/toggleEdit", false);
    },
    ...mapActions({
      setNavigationActive: "globalApp/setNavigationActive"
    })
  }
};
</script>
